export default __webpack_public_path__ + "static/media/brand-pattern.07ffece8.jpg";